<template>
  <div class="orders-page pb-12">
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />

    <v-container>
      <v-layout wrap>
        <!-- Header Section -->
        <v-flex xs12 class="mb-8">
          <div class="d-flex align-center">
            <v-icon color="#3EA56E" class="mr-3" size="28">mdi-package-variant-closed</v-icon>
            <h1 class="page-title">Order History</h1>
          </div>
          <v-divider class="title-divider mt-2"></v-divider>
        </v-flex>

        <!-- Orders List -->
        <v-flex xs12 v-if="products && products.length > 0">
          <v-layout wrap>
            <v-flex xs12>
              <v-expansion-panels flat class="orders-panels">
                <v-expansion-panel v-for="(item, i) in products" :key="i" class="order-panel mb-4">
                  <v-expansion-panel-header class="pa-4 py-6" :class="{ 'alt-bg': i % 2 !== 0 }">
                    <template v-slot:default>
                      <v-row no-gutters align="center">
                        <v-col cols="12" sm="6">
                          <div class="d-flex flex-column">
                            <span class="order-id-label">Order #{{ item.orderid }}</span>
                            <span class="order-date">{{ formatDate(item.date) }}</span>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" class="text-sm-right mt-2 mt-sm-0">
                          <v-chip
                            small
                            label
                            class="status-chip ibmmedium"
                            :color="getStatusColor(item.status)"
                            text-color="white"
                          >
                            {{ item.status || 'Processed' }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-header>
                  
                  <v-expansion-panel-content class="order-content">
                    <v-divider></v-divider>
                    <div class="items-list pt-4">
                      <div v-for="(item1, j) in item.items" :key="j" class="order-item-row pa-4 mb-2">
                        <v-row align="center">
                          <v-col cols="4" sm="2" class="text-center">
                            <template v-if="item1.productId.photos && item1.productId.photos.length > 0">
                              <v-img
                                :src="baseURL + 'u/' + item1.productId.photos[0]"
                                height="80"
                                contain
                                class="rounded-lg item-thumb"
                              ></v-img>
                            </template>
                            <template v-else>
                              <v-img
                                :src="require('../../../assets/noimg.png')"
                                height="80"
                                contain
                                class="rounded-lg item-thumb"
                              ></v-img>
                            </template>
                          </v-col>
                          <v-col cols="8" sm="6">
                            <h4 class="item-name mb-1">{{ item1.productname }}</h4>
                            <div class="item-meta d-flex">
                              <span class="meta-label mr-2">Qty:</span>
                              <span class="meta-value">{{ item1.quantity }} {{ item1.productId.unit }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" sm="4" class="text-sm-right">
                            <div class="item-price">₹{{ item1.TotalAmount }}</div>
                            <div class="item-status-text" :style="{ color: getStatusColor(item1.orderStatus) }">
                              {{ item1.orderStatus }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>

            <!-- Pagination -->
            <v-flex xs12 class="mt-8">
              <v-pagination
                v-model="page"
                :length="Pagelength"
                :total-visible="7"
                color="#3EA56E"
                circle
                class="custom-pagination"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Empty State -->
        <v-flex xs12 v-else-if="!appLoading" class="text-center py-16">
          <div class="empty-orders-container">
            <v-icon size="80" color="#e2e8f0" class="mb-4">mdi-package-variant</v-icon>
            <h2 class="empty-title mb-2">No orders found</h2>
            <p class="empty-description mb-8">Looks like you haven't placed any orders yet. Explore our products and start shopping!</p>
            <v-btn
              color="#3EA56E"
              dark
              depressed
              to="/products"
              class="explore-btn px-10 py-6 rounded-lg"
            >
              Start Shopping
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      products: [],
      ServerError: false,
      searchKey: null,
      page: 1,
      Pagelength: 0,
      limit: 10, // Adjusted limit for better UX
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/my/orders/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          page: this.page,
          limit: this.limit,
          filterType: "today",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            this.Pagelength = Math.ceil(response.data.totalLength / this.limit);
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error("Error fetching orders:", err);
        });
    },
    formatDate(item) {
      if (!item) return "";
      const dt = new Date(item);
      const options = { 
        day: 'numeric', 
        month: 'short', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      };
      return dt.toLocaleDateString('en-IN', options);
    },
    getStatusColor(status) {
      if (!status) return "#3EA56E";
      const s = status.toLowerCase();
      if (s.includes('cancel') || s.includes('reject')) return "#ef4444";
      if (s.includes('deliver')) return "#10b981";
      if (s.includes('process') || s.includes('active')) return "#3EA56E";
      if (s.includes('ship')) return "#3b82f6";
      return "#64748b";
    }
  },
};
</script>

<style scoped>
.orders-page {
  background-color: #f8fafc;
  min-height: 100vh;
}

.page-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 26px;
  color: #1a202c;
  margin: 0;
}

.title-divider {
  border-color: #3EA56E;
  max-width: 60px;
  border-width: 3px;
  opacity: 1;
}

.order-panel {
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px !important;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.order-panel:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.order-panel::before {
  display: none;
}

.alt-bg {
  background-color: #f8fafc;
}

.order-id-label {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  color: #1e293b;
}

.order-date {
  font-family: "sofialight", sans-serif;
  font-size: 13px;
  color: #64748b;
}

.status-chip {
  font-family: "ibmmedium", sans-serif;
  font-size: 11px;
  letter-spacing: 0.5px;
  padding: 4px 12px;
}

.order-content {
  background-color: #ffffff;
}

.order-item-row {
  border: 1px solid #f1f5f9;
  border-radius: 12px;
}

.item-thumb {
  border: 1px solid #f1f5f9;
}

.item-name {
  font-family: "ibmsemibold", sans-serif;
  font-size: 16px;
  color: #334155;
  margin: 0;
}

.meta-label {
  font-family: "sofialight", sans-serif;
  font-size: 13px;
  color: #94a3b8;
}

.meta-value {
  font-family: "ibmmedium", sans-serif;
  font-size: 13px;
  color: #475569;
}

.item-price {
  font-family: "ibmsemibold", sans-serif;
  font-size: 18px;
  color: #1a202c;
}

.item-status-text {
  font-family: "ibmmedium", sans-serif;
  font-size: 13px;
}

.empty-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 24px;
}

.empty-description {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
}

.explore-btn {
  font-family: "ibmsemibold", sans-serif;
  text-transform: none !important;
  font-size: 16px;
}

.ibmmedium {
  font-family: "ibmmedium", sans-serif;
}

.custom-pagination >>> .v-pagination__item,
.custom-pagination >>> .v-pagination__navigation {
  box-shadow: none !important;
  border: 1px solid #e2e8f0;
  font-family: "ibmsemibold", sans-serif;
}

.custom-pagination >>> .v-pagination__item--active {
  color: white !important;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 22px;
  }
}
</style>